import type { LegacyReferralViewModel } from '@generated';
import React, { type ReactNode } from 'react';

interface LegacyReferralContextValue {
	referral: LegacyReferralViewModel;
}

const LegacyReferralContext = React.createContext<LegacyReferralContextValue | null>(null);

interface LegacyReferralProviderProps extends LegacyReferralContextValue {
	children: React.ReactNode;
}

export function LegacyReferralProvider({ referral, children }: LegacyReferralProviderProps): ReactNode {
	return <LegacyReferralContext.Provider value={{ referral }}>{children}</LegacyReferralContext.Provider>;
}

export function useLegacyReferralContext(): LegacyReferralContextValue {
	const context = React.useContext(LegacyReferralContext as React.Context<LegacyReferralContextValue | null>);

	if (context === null) {
		throw new Error('useLegacyReferralContext must be used within a LegacyReferralProvider');
	}

	return context;
}
